import { render, staticRenderFns } from "./radio-button.component.vue?vue&type=template&id=3f1fc98d&scoped=true&"
import script from "./radio-button.component.vue?vue&type=script&lang=ts&"
export * from "./radio-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./radio-button.component.vue?vue&type=style&index=0&id=3f1fc98d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fc98d",
  null
  
)

export default component.exports